import React, { useRef } from 'react';
import { placeholderFor } from './productShopMapper';

// A product tile: media (real photo or a clean gradient placeholder), name,
// price, and a quick "+" add that fires the fly-to-basket animation. The media
// element is handed to onAdd so the modal can clone + fly it.

const PlusIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden><path d="M12 5v14M5 12h14" /></svg>
);

export const BottleGlyph = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M10 2.5h4M10 2.5v2.2c0 .5-.2 1-.6 1.4L8 7.8A3 3 0 0 0 7 10v9.5A1.5 1.5 0 0 0 8.5 21h7a1.5 1.5 0 0 0 1.5-1.5V10a3 3 0 0 0-1-2.2l-1.4-1.7c-.4-.4-.6-.9-.6-1.4V2.5" />
    <path d="M7 12.5h10" />
  </svg>
);

const ProductCard = ({ product, currency = '£', onOpen, onAdd, compact = false }) => {
  const mediaRef = useRef(null);
  const img = product.images && product.images[0];
  const mediaStyle = img ? { backgroundImage: `url(${img})` } : { background: placeholderFor(product.name.length) };

  return (
    <div
      className={`ps-card ${compact ? 'ps-card--compact' : ''}`}
      role="button"
      tabIndex={0}
      onClick={() => onOpen(product.id)}
      onKeyDown={(e) => { if (e.key === 'Enter') onOpen(product.id); }}
    >
      <div className="ps-card-media" ref={mediaRef} style={mediaStyle}>
        {!img && <span className="ps-card-glyph" aria-hidden><BottleGlyph size={compact ? 26 : 34} /></span>}
        {product.inStock === false ? (
          <span className="ps-card-oos">Out of stock</span>
        ) : (onAdd && (
          <button
            type="button"
            className="ps-card-add"
            aria-label={`Add ${product.name} to basket`}
            onClick={(e) => { e.stopPropagation(); onAdd(product.id, 1, null); }}
          >
            <PlusIcon />
          </button>
        ))}
      </div>
      <div className="ps-card-info">
        <h3 className="ps-card-name">{product.name}</h3>
        <p className="ps-card-price">{currency}{product.price.toFixed(2)}</p>
      </div>
    </div>
  );
};

export default ProductCard;
